import { LOCALES } from 'i18n/locales';

export const EnquirySummaryIntl = {
    [LOCALES.ENGLISH]: {
        'EnquirySummary.title': 'Name',
        'EnquirySummary.type.title': 'Enquiry type',
        'EnquirySummary.type.organisation.name': 'Organisational sponsor',
        'EnquirySummary.details.title': 'Enquiry details',
        'EnquirySummary.jobReference': 'Reference code (optional)',
        'EnquirySummary.description': 'Description',
        'EnquirySummary.activity.type.value': 'Activity type value',
        'EnquirySummary.activity.type.category': 'Activity type category',
        'EnquirySummary.enquiryType': 'Utility enquiry type',
        'EnquirySummary.enquiryType.emergency': 'Emergency works',
        'EnquirySummary.enquiryType.planned': 'Planned works',
        'EnquirySummary.startDate': 'Start date',
        'EnquirySummary.endDate': 'End date',
        'EnquirySummary.workpack': 'Enquiry workpack',
        'EnquirySummary.workpack.download.button': 'Download workpack',
        'EnquirySummary.workpack.download.available': 'Your PDF is available to download',
        'EnquirySummary.workpack.download.generating': 'Your PDF failed to generate. Please try again or else contact support.',
        'EnquirySummary.supportingLinks': 'Supporting links',
        'EnquirySummary.comments': 'Comments',
        'EnquirySummary.specialRequirements': 'Special requirements',
        'EnquirySummary.specialRequirements.hint': 'Organisations may have special guidance or requirements for third parties working near their assets. You must ensure that you comply with all requirements for safe working and contact the asset owner if in doubt or if directed.',
        'EnquirySummary.organisation': 'Asset owner',
        'EnquirySummary.specialMeasure': 'Special measure',
        'EnquirySummary.summaryTable': 'Summary of special requirements in your enquiry area.'
    },
    [LOCALES.WELSH]: {
        'EnquirySummary.title': '[Name]',
        'EnquirySummary.type.title': '[Enquiry type]',
        'EnquirySummary.type.organisation.name': '[Organisational sponsor]',
        'EnquirySummary.details.title': '[Enquiry details]',
        'EnquirySummary.jobReference': '[Your reference]',
        'EnquirySummary.description': '[Description]',
        'EnquirySummary.activity.type.value': '[Activity type value]',
        'EnquirySummary.activity.type.category': '[Activity type category]',
        'EnquirySummary.enquiryType': '[Utility enquiry type]',
        'EnquirySummary.enquiryType.emergency': '[Emergency works]',
        'EnquirySummary.enquiryType.planned': '[Planned works]',
        'EnquirySummary.startDate': '[Start date]',
        'EnquirySummary.endDate': '[End date]',
        'EnquirySummary.workpack': '[Enquiry workpack]',
        'EnquirySummary.workpack.download.button': '[Download workpack]',
        'EnquirySummary.workpack.download.available': '[Your PDF is available to download]',
        'EnquirySummary.workpack.download.generating': '[Your PDF failed to generate. Please try again or else contact support.]',
        'EnquirySummary.supportingLinks': '[Supporting links]',
        'EnquirySummary.comments': '[Comments]',
        'EnquirySummary.specialRequirements': '[Special requirements]',
        'EnquirySummary.specialRequirements.hint': '[Organisations may have special guidance or requirements for third parties working near their assets. You must ensure that you comply with all requirements for safe working and contact the asset owner if in doubt or if directed.]',
        'EnquirySummary.organisation': '[Asset owner]',
        'EnquirySummary.specialMeasure': '[Special measure]',
        'EnquirySummary.summaryTable': '[Summary of special requirements in your enquiry area.]'
    }
};
